var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ht-view-container"},[_c('div',{ref:"htView",staticClass:"ht-view"})])}
var staticRenderFns = []

export { render, staticRenderFns }